import React from 'react';

import { AliasToken } from 'antd/es/theme/internal';
import { windowBreakpoints } from '../hooks/useDeviceSize';
import { responsiveStyle } from '../util/helpers';

export const containerStyle = (globalStyle: AliasToken, viewportSize: windowBreakpoints) =>
  responsiveStyle(viewportSize, {
    root: {
      backgroundColor: globalStyle.colorBgLayout,
      flex: 1,
    },
    main: {
      backgroundColor: globalStyle.colorBgLayout,
      height: '100%',
      margin: '-1px 0px',
      '!desktop': {
        display: 'inline',
      },
    },
  });

export default containerStyle;
